import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Escape } from '../../../../services/Escape';
import { useDisablePageScroll } from '../../../../internal/hooks/useDisablePageScroll';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонента для рендера модальных окон
 */
export const Modal = /*#__PURE__*/React.memo(_ref => {
  let {
    open,
    onClose,
    children,
    escape = true,
    portal = true
  } = _ref;
  const host = typeof document !== 'undefined' ? document.body : null;
  useDisablePageScroll(open);
  if (!host || !open) {
    return null;
  }
  const component = /*#__PURE__*/_jsx(Escape, {
    onEscape: onClose,
    active: !!escape,
    children: children
  });
  return portal ? /*#__PURE__*/ReactDOM.createPortal(component, host) : component;
});
Modal.displayName = 'Modal';